import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import '../../App.scss';
import { usePdfContext } from '../PdfContext';
import { storage } from '../../firebase';
import { ref, getDownloadURL } from 'firebase/storage';
import ModelCore from '../model-viewer/ModelCore';
import Modal from '../popup-modal/Modal'; // Path to the Modal component
import ModelViewer from '../model-viewer/ModelViewer';
import { useConfig } from '../../useConfig';
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import AssetClassTypeViewer from './AssetClassTypeViewer';
import { pdfAnnotElements, annotLabels, getLinkType } from '../../services/helper-function.service';
import AssetWorkflow from './AssetWorkflow';


function AnnotViewer({ SD_annot, SD_pdfPropts, label }) {
    const { state, action } = { ...SD_pdfPropts };
    const procMode = label === annotLabels?.proc ? true : false;
    const [annotOnPage, setAnnotOnPage] = useState(null);
    const [annotation, setAnnotation] = useState(null);
    const [annotInd, setAnnotInd] = useState(0);
    const [subAnnotation, setSubAnnotation] = useState(null);
    const [subAnnotInd, setSubAnnotInd] = useState(null);
    const pdfObj = usePdfContext();
    const isAndroid = pdfObj.isAndroid;
    const [imageUrl, setImageUrl] = useState(null);
    const [videoUrl, setVideoUrl] = useState(null);
    const [popup, setPopup] = useState(false);
    const [popupMedia, setPopupMedia] = useState(null);
    const [model, setModel] = useState({ url: '', type: '' });
    const [annotationNumber, setAnnotationNumber] = useState('');
    const [annotationClassification, setAnnotationClassification] = useState('');
    const [annotationDescription, setAnnotationDescription] = useState('');
    const [assetProcedure, setComment] = useState('');
    const config = useConfig();
    const [isPhotoVisible, setIsPhotoVisible] = useState(false);
    const [isVideoVisible, setIsVideoVisible] = useState(false);
    const [isModelVisible, setIsModelVisible] = useState(false);
    const [showAssetClassModal, setShowAssetClassModal] = useState(false);
    const [assetClassUrl, setAssetClassUrl] = useState(null);
    const [showAssetWorkflow, setShowAssetWorkflow] = useState(false);


    // New state variable to manage the active form and its XML content URL
    const [activeForm, setActiveForm] = useState({
        id: '', // Identifies the active form (e.g., 'FORM1', 'FORM2', etc.)
        url: '', // The URL to the XML content for the active form
    });

    const closeAssetWorkflowModal = () => {
        setShowAssetWorkflowModal(false);
    };

    const handleViewAssetClassType = async (url) => {
        if (!url) {
            // Display a visual notification
            alert('Technical Support Information Not Available');

            // Additionally, use Text-to-Speech to notify the user audibly
            try {
                await TextToSpeech.speak({
                    text: 'Technical Support Information Not Available',
                    lang: 'en-US', // Optionally, specify the language
                    rate: 1.0,     // Optionally, specify the speed rate
                    volume: 0.0,   // Optionally, specify the volume
                    pitch: 1.0,    // Optionally, specify the pitch
                });
            } catch (error) {
                console.error('TTS Error:', error);
            }
            return;
        }
        setAssetClassUrl(url);
        setShowAssetClassModal(true);
    };

    // Example function to handle viewing asset forms
    const handleViewAssetForm = async (formUrlIdentifier, formNumber) => {
        if (!formUrlIdentifier) {

            // Display a visual notification
            alert('Asset Form Not Yet Assigned');
            // Use Text-to-Speech to notify the user if the form URL is not provided
            try {
                await TextToSpeech.speak({
                    text: `Asset Form ${formNumber} not yet assigned`,
                    lang: 'en-US', // Optionally, specify the language
                    rate: 1.0,     // Optionally, specify the speed rate
                    volume: 1.0,   // Optionally, specify the volume
                    pitch: 1.0,    // Optionally, specify the pitch
                });
            } catch (error) {
                console.error('TTS Error:', error);
            }
            return;
        }

        try {
            // Assume formUrlIdentifier is directly usable or adjusted to fetch from Firebase
            const formUrl = formUrlIdentifier; // Adjust as needed for fetching logic

            // Logic to open and populate the modal with the form content
            setActiveForm({ url: formUrl }); // Example of setting state to trigger modal display
            setShowAssetWorkflowModal(true); // Assuming this is the method to show the modal
        } catch (error) {
            console.error('Failed to load form URL:', error);
        }
    };

    // Create a state variable for the AssetWorkflow modal
    const [showAssetWorkflowModal, setShowAssetWorkflowModal] = useState(false);

    // Adjust the openAssetWorkflowModal function to accept a form identifier



    const [showModal, setShowModal] = useState(false);
    const [modalUrl, setModalUrl] = useState('');

    const openModal = (url, width, height) => {
        setModalUrl(url);
        setShowModal({ width: width, height: height });
    };



    /**
     * function sets a link on page to enable coloring a selected annotation to give the impression of
     * annotation being highlighted/active
     * @param {*} annotation
     */
    const updateHash = (annotation) => {
        document.location.hash = `kID-${annotation.id},`;
        action({
            type: 'chng-active-annot',
            data: annotation,
        });
    };

    const getSelectedHighlight = (annotation) => {
        const selectedOpt = pdfAnnotElements.find(
            (ele) => ele.key === annotation?.icon
        );
        return selectedOpt?.ele;
    };



    useEffect(() => {
        const selectedAnnotId = state?.mode?.selectedAnnotId;
        let annotArr = [];
        const annotState = SD_annot?.state;
        let presetInd = 0;
        for (let i = 0; i < annotState?.length; i++) {
            if (
                procMode &&
                annotState[i]?.position?.pageNumber ===
                SD_pdfPropts?.state?.pages?.curr &&
                pdfObj?.state?.fullPath === annotState[i]?.comment[0]?.key
            ) {
                if (selectedAnnotId && selectedAnnotId === annotState[i]?.id) {
                    presetInd = i;
                }
                annotArr.push({
                    ...annotState[i],
                    assetClassification: annotState[i]?.comment[0]?.assetClassification,
                    assetDescription: annotState[i]?.comment?.assetDescription,
                    assetNumber: annotState[i]?.comment?.assetNumber,
                    assetLocation: annotState[i]?.comment?.assetLocation,
                    assetDepartment: annotState[i]?.comment?.assetDepartment,
                    assetProcedure: annotState[i]?.comment?.assetProcedure,
                    ClassIUrl: annotState[i]?.comment?.ClassIUrl

                });
            } else if (
                !procMode &&
                annotState[i]?.position?.pageNumber ===
                SD_pdfPropts?.state?.pages?.curr &&
                pdfObj?.state?.fullPath === annotState[i]?.comment?.key
            ) {
                if (selectedAnnotId && selectedAnnotId === annotState[i]?.id) {
                    presetInd = i;
                }
                annotArr.push({
                    ...annotState[i],
                    assetClassification: annotState[i]?.comment?.assetClassification,
                    assetDescription: annotState[i]?.comment?.assetDescription,
                    assetNumber: annotState[i]?.comment?.assetNumber,
                    assetLocation: annotState[i]?.comment?.assetLocation,
                    assetDepartment: annotState[i]?.comment?.assetDepartment,
                    assetProcedure: annotState[i]?.comment?.assetProcedure,
                });
            }
        }
        // force update annotation array
        if (annotInd === presetInd) updateAnnot(annotArr, presetInd);
        if (subAnnotInd === 0) updateSubAnnot(annotArr[presetInd], 0);

        setAnnotOnPage(annotArr);
        setAnnotInd(presetInd);
        setSubAnnotInd(0);
    }, [state?.pages?.curr, state?.mode?.selectedAnnotId]);

    /**
     * get downloadable viewable link from an image/video element in a pdf annotation
     * @param {*} fbUrl
     * @param {*} urlSetter
     */
    const downloadMediaUrl = async (fbUrl, urlSetter) => {
        const storageRef = ref(storage, fbUrl);
        const url = await getDownloadURL(storageRef);
        urlSetter(url);
    };

    /**
     * populates media and model elements of a downloaded annotation
     * @param {*} annotArr
     * @param {*} ind
     * @returns
     */
    const updateAnnot = (annotArr, ind) => {
        if (annotArr && ind >= 0 && ind < annotArr.length) {
            setAnnotation(annotArr[ind]);
            if (procMode) return;
            if (annotArr[ind]?.comment?.video)
                downloadMediaUrl(annotArr[ind]?.comment?.video, setVideoUrl);
            if (annotArr[ind]?.comment?.img)
                downloadMediaUrl(annotArr[ind]?.comment?.img, setImageUrl);
            const newModel = {
                type: getLinkType(annotArr[ind]?.comment?.model),
                url: annotArr[ind]?.comment?.model,
            };
            setModel(newModel);
            return annotArr[ind];
        }
    };





    const updateAnnotInd = (newInd) => {
        if (newInd < 0 || newInd >= annotOnPage.length) {
            return;
        }
        setAnnotInd(newInd);
    };

    useEffect(() => {
        updateAnnot(annotOnPage, annotInd);
        if (procMode) {
            if (subAnnotInd === 0) updateSubAnnot(annotOnPage[annotInd], 0);
            setSubAnnotInd(0);
        }
    }, [annotInd]);

    const updateSubAnnotInd = (newInd) => {
        if (newInd < 0 || newInd >= annotation?.comment.length) {
            return;
        }
        setSubAnnotInd(newInd);
    };


    const updateSubAnnot = (annot = annotation, ind = subAnnotInd) => {
        if (annot && ind >= 0 && ind < annot?.comment.length) {
            setSubAnnotation(annot?.comment[ind]);
            const subAnnot = annot?.comment[ind];
            if (subAnnot?.video) downloadMediaUrl(subAnnot?.video, setVideoUrl);
            if (subAnnot?.img) downloadMediaUrl(subAnnot?.img, setImageUrl);
            const newModel = {
                type: getLinkType(subAnnot?.model),
                url: subAnnot?.model,
            };
            setModel(newModel);
        }
    };


    useEffect(() => {
        updateSubAnnot();
    }, [subAnnotInd]);


    /*     // this code should identify the ammount of high priority tasks as defined by asset status icon //
    
        useEffect(() => {
            if (annotOnPage && !procMode) {
                const numItems = annotOnPage.length;
                const numHighPriorityItems = annotOnPage.filter(item => item.icon === 'i1').length;
                TextToSpeech.speak({
                    text: `You have ${numItems} assets requiring attention of which ${numHighPriorityItems} are of high priority`,
                    locale: 'en_US',
                    rate: 1.0,
                });
            }
        }, [annotOnPage, procMode]);
     */





    return (
        <>
            <div id="lotoIframeContainer" style={{ display: 'none' }}>
                <iframe title="lotoIframe" id="lotoIframe" width="400" height="400"></iframe>
                <button onClick={() => document.getElementById('lotoIframeContainer').style.display = 'none'}>Close</button>
            </div>

            {/*             <div className="menu-hdr">
                <button
                    className="menu-hdr-icon"
                    onClick={() => updateAnnotInd(annotInd - 1)}
                >
                    <FaArrowLeft />
                    {isAndroid ? 'BACK' : ''}
                </button>
                <div className="menu-hdr-label" data-wearml="open-ppe">NAVIGATE</div>
                <button
                    className="menu-hdr-icon"
                    onClick={() => updateAnnotInd(annotInd + 1)}
                >
                    {isAndroid ? 'FORWARD' : ''}
                    <FaArrowRight />
                </button>
            </div> */}



            <div className={'annot-list' + (isAndroid ? ' android' : '')}>
                {annotation?.position?.pageNumber === state?.pages?.curr ? (
                    procMode ? (
                        <>
                            <div
                                className="ele-hlt"
                                onClick={() => {
                                    updateHash(annotation);
                                }}
                            >
                                <div className="hlt-comp">
                                    Asset Number: {subAnnotation?.assetNumber}
                                </div>
                                <div className="hlt-comment">
                                    <button onClick={() => {
                                        TextToSpeech.speak({
                                            text: subAnnotation?.comment,  // This is the text to be read aloud
                                            locale: 'en_US',
                                            rate: 1.0,
                                        });
                                    }}>
                                        Play Step {subAnnotInd}
                                    </button> {subAnnotation?.comment}


                                </div>


                            </div>

                        </>
                    ) : (
                        <>
                            <div
                                className="ele-hlt"
                                onClick={() => {
                                    updateHash(annotation);
                                }}
                            >
                                <div className="hlt-comp">                                            <button
                                    className="workflow-btn"
                                    onClick={() => handleViewAssetClassType(annotation?.comment?.assetClassIIUrl)}
                                    data-wearml="open-asset-class-type"
                                >
                                    TROUBLESHOOTING
                                </button>

                                    <button onClick={(e) => {
                                        openModal(imageUrl, 400, 400);  // Adjusted to use openModal
                                        e.stopPropagation();
                                    }}
                                        data-wearml="open-photo"
                                    >
                                        ASSET PHOTO
                                    </button>


                                    <button onClick={(e) => {
                                        openModal(videoUrl, 400, 400);  // Adjusted to use openModal
                                        e.stopPropagation();
                                    }}
                                        data-wearml="open-video"
                                    >
                                        ASSET VIDEO</button>

                                    {/* 
                                    <button onClick={() => {
                                        window.open("https://cdn.glitch.global/f38546bc-35cc-4e2a-a855-6e6b8982eaf6/MotorAssy.glb", "_blank");
                                    }}
                                        data-wearml="open-AR"
                                    >
                                        XR MODE
                                    </button> */}


                                    <div className="hlt-icon">
                                        {label === annotLabels?.tribal ? 'Asset Type' : ''}
                                        {getSelectedHighlight(annotation?.comment)}
                                    </div>


                                    {/* <p></p><div style={{ display: 'flex', alignItems: 'center' }}>  {getSelectedHighlight(annotation?.comment)} ---  {annotation?.comment?.icon} --- {getSelectedHighlight(annotation?.comment)}</div> */}

                                    <div><li>Asset Number: {annotation?.comment?.assetNumber}</li></div>
                                    <div><li>Asset Description: {annotation?.comment?.assetDescription}</li></div>
                                    <div><li>Asset Classification: {annotation?.comment?.assetClassification}</li></div>
                                    <div><li>Asset Department: {annotation?.comment?.assetDepartment}</li></div>

                                    <button
                                        className="workflow-btn"
                                        onClick={() => handleViewAssetForm(annotation?.comment?.['assetForm1Url'], 1)}
                                        data-wearml="open-form1"
                                    >CHECK 1</button>

                                    <button
                                        className="workflow-btn"
                                        onClick={() => handleViewAssetForm(annotation?.comment?.['assetForm2Url'], 2)}
                                        data-wearml="open-form2"
                                    >CHECK 2</button>
                                    <button
                                        className="workflow-btn"
                                        onClick={() => handleViewAssetForm(annotation?.comment?.['assetForm3Url'], 3)}
                                        data-wearml="open-form3"
                                    >CHECK 3</button>
                                    <button
                                        className="workflow-btn"
                                        onClick={() => handleViewAssetForm(annotation?.comment?.['assetForm4Url'], 4)}
                                        data-wearml="open-form4"
                                    >CHECK 4</button>
                                    <button
                                        className="workflow-btn"
                                        onClick={() => handleViewAssetForm(annotation?.comment?.['assetForm5Url'], 5)}
                                        data-wearml="open-form5"
                                    >CHECK 5</button>





                                    {showAssetClassModal && (
                                        <Modal show={showAssetClassModal} onClose={() => setShowAssetClassModal(false)}>
                                            <AssetClassTypeViewer url={assetClassUrl} />
                                        </Modal>
                                    )}
                                </div>

                            </div>

                            <div className="ele-hlt">
                                {/* Add a button to open the AssetWorkflow modal */}


                                {/* Render the AssetWorkflow modal */}
                                {showAssetWorkflowModal && (
                                    <Modal show={showAssetWorkflowModal} onClose={closeAssetWorkflowModal}>
                                        <AssetWorkflow formUrl={activeForm.url} /> {/* Pass the active form URL as a prop */}
                                    </Modal>
                                )}



                                <Modal show={showModal} onClose={() => setShowModal(false)}>
                                    <iframe
                                        src={modalUrl}
                                        width={showModal.width}
                                        height={showModal.height}
                                        title="Content"
                                    />
                                </Modal>



                                <div className="hlt-model">

                                    {model.url && <ModelViewer SD_pdfPropts={SD_pdfPropts} modelArr={[model]} isAndroid={isAndroid} />}
                                </div>

                                <div
                                    className="hlt-media"
                                    onClick={() => {
                                        if (!isAndroid) {
                                            setPopup(true);
                                            setPopupMedia({
                                                type: 'img',
                                                src: imageUrl,
                                            });
                                        }
                                    }}
                                >
                                </div>
                                <div
                                    className="hlt-media"
                                    onClick={() => {
                                        if (!isAndroid && videoUrl) {
                                            openModal(videoUrl, 400, 400);
                                        }
                                    }}
                                >


                                    {isPhotoVisible && (
                                        <div
                                            className="hlt-media"
                                            onClick={() => {
                                                if (!isAndroid && imageUrl) {
                                                    window.open(imageUrl, '_blank', 'width=400,height=400');
                                                }
                                            }}
                                        >
                                            {subAnnotation?.img && (
                                                <img
                                                    src={imageUrl}
                                                    alt=""
                                                    className="hlt_col"
                                                />
                                            )}
                                        </div>
                                    )}


                                    {isVideoVisible && (
                                        <div
                                            className="hlt-media"
                                            onClick={() => {
                                                if (!isAndroid && videoUrl) {
                                                    openModal(videoUrl, 400, 400);
                                                }
                                            }}
                                        >
                                            {subAnnotation?.img && (
                                                <video
                                                    src={videoUrl}

                                                    className="hlt_col"
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>



                        </>
                    )
                ) : null}
            </div>

        </>
    );
}

export default AnnotViewer;

